export default __webpack_public_path__ + "static/image_activities_s-21cd0844e7ba4e4301df01e2aa2dc919.jpg";